import * as React from 'react';
import calculateTotalScore from './../../utilities/calculate-total-score';
import Timer, { INITIAL_SCORE } from './../timer/timer';
import Scores from './../scores/scores';
import Submit from './../submit/submit';

// The question data is loaded globally later.
declare const QuizData: QuizData;

interface Props {
    bufferMilliseconds: number;
    calculateMaximumScore?: (state: QuizState) => number;
    calculateRoundScore: (state: QuizState) => RoundScore[];
    changeInputTarget?: (round: Round, inputTarget: string | null, direction?: number) => string | null;
    render: (state: QuizState) => JSX.Element;
    scoreMilliseconds: number;
}

export interface QuizState {
    inputTarget: string | null;
    isRoundInterval: boolean;
    roundIndex: number;
    rounds: Round[];
    roundScores: RoundScore[][];
}

export default class Quiz extends React.Component<Props, QuizState> {

    roundTimerScore: number;

    constructor(props: Props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.updateTimerScore = this.updateTimerScore.bind(this);
        this.state = {
            isRoundInterval: false,
            roundIndex: 0,
            roundScores: [],
            rounds: QuizData.rounds,
            inputTarget: props.changeInputTarget ? props.changeInputTarget(QuizData.rounds[0], null) : null
        };
    }

    render(): JSX.Element {
        return (
            <div className="quiz">
                <div className="quiz-controls">
                    <Timer
                        bufferMilliseconds={this.props.bufferMilliseconds}
                        isRoundInterval={this.state.isRoundInterval}
                        roundIndex={this.state.roundIndex}
                        roundScores={this.state.roundScores}
                        roundCount={this.state.rounds.length}
                        scoreMilliseconds={this.props.scoreMilliseconds}
                        updateScore={this.updateTimerScore}
                    />
                    <Submit
                        isRoundInterval={this.state.isRoundInterval}
                        roundIndex={this.state.roundIndex}
                        roundCount={this.state.rounds.length}
                        submit={this.submit}
                    />
                    <Scores
                        isRoundInterval={this.state.isRoundInterval}
                        roundScores={this.state.roundScores}
                    />
                </div>
                {this.props.render(this.state)}
            </div>
        );
    }

    /**
     * Go to the results screen.
     */
    showResults(): void {
        
        const score = calculateTotalScore(this.state.roundScores);

        // Child components can specify the total possible score if some extra logic is needed.
        const maximumScore = this.props.calculateMaximumScore ? 
            this.props.calculateMaximumScore(this.state) :
            this.state.rounds.length * (1000 + INITIAL_SCORE);
        
        // Add the player's results to the session storage.
        const percentage = score === 0 ? 0 : score / maximumScore;
        sessionStorage.setItem('results', JSON.stringify({ score, percentage }));
    
        // Navigate to the results page.
        const url = window.location.href;
        window.location.assign(url + '-results');
            
    }

    /**
     * Go to the next round, or finish the game if there are no more rounds left.
     */
    submit(): void {

        if (this.state.isRoundInterval === true) {

            const roundIndex = this.state.roundIndex + 1;

            if (this.state.roundIndex >= this.state.rounds.length - 1) {
                this.showResults();
            } else {
                this.setState({
                    roundIndex: roundIndex,
                    isRoundInterval: false,
                    inputTarget: typeof this.props.changeInputTarget === 'undefined'
                        ? null
                        : this.props.changeInputTarget(this.state.rounds[roundIndex], this.state.inputTarget)
                });
            }

        } else {

            const roundScores = this.props.calculateRoundScore(this.state);
            roundScores.push({ label: 'Time', score: this.roundTimerScore });

            this.setState({
                isRoundInterval: true,
                roundScores: this.state.roundScores.concat([roundScores])
            });

        }
    }

    /**
     * Record an update to the timer.
     * @param roundTimerScore The timer's current value.
     */
    updateTimerScore(roundTimerScore: number): void {
        this.roundTimerScore = roundTimerScore;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/globals/components/quiz/quiz.tsx